import { withStyles } from "@material-ui/core/styles";
import "assets/css/form-auto.css";
import {} from "assets/jss/material-dashboard-react.js";
import AssociationList from "components/AssociationList";
import CustomTabs from "components/CustomTabs/CustomTabs";
import Form from "components/MuiJsonForm";
import axios from "axios";
import PubSub from "pubsub-js";
import queryString from "query-string";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Actions from "redux/actions";
import {
  appartementColumns,
  fichierColumns,
  missionColumns,
  quitanceColumns,
} from "utils/columns";
import downloadFile from "utils/downloadFile";
import fileDialog from "utils/fileDialog";
import { clientSchema, fichierSchema, missionSchema } from "utils/schemas";

class FormEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, formData: {}, initLoad: true };
    this.dispatch = this.props.dispatch;
    this.isNew = props.match.params.id === "new";
    this.edit = props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    this.cancelSources = new Set();
    this.timeouts = new Set();
    this.subs = [];
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.clearTimeouts();
    this.cancelAllRequests("ClientEditor unmounted");
    this.unsubscribeAll();
  }

  componentDidUpdate(prevProps) {
    this.isNew = this.props.match.params.id === "new";
    this.edit = this.props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;
    if (this.props.match.params !== prevProps.match.params) {
      this.loadData();
    }
  }

  loadData = () => {
    this.isNew = this.props.match.params.id === "new";
    this.edit = this.props.match.params.edit ? true : false;
    this.readOnly = !this.isNew && !this.edit;

    this.cancelAllRequests("ClientEditor remount");
    this.clearTimeouts();
    let action = [];
    if (!this.state.initLoad)
      this.updateState({
        loading: true,
        formData: {},
        initLoad: true,
      });
    const clientSource = this.createCancelSource();
    action.push(
      this.trackPromise(
        this.dispatch(
          Actions.getClient(this.props.match.params.id, {
            cancelToken: clientSource.token,
          })
        ),
        clientSource
      )
    );
    // On decale les requetes appartements pour ne pas bloquer l'affichage initial.
    this.addTimeout(() => {
      if (!this._isMounted || this.isNew) return;
      const appartSource = this.createCancelSource();
      this.trackPromise(
        this.dispatch(
          Actions.getAppartements({ cancelToken: appartSource.token })
        ),
        appartSource
      );
      const missionSource = this.createCancelSource();
      this.trackPromise(
        this.dispatch(Actions.getMissions({ cancelToken: missionSource.token })),
        missionSource
      );
    }, 500);
    const quitancesSource = this.createCancelSource();
    action.push(
      this.trackPromise(
        this.dispatch(Actions.getQuitances({ cancelToken: quitancesSource.token })),
        quitancesSource
      )
    );
    const clientsSource = this.createCancelSource();
    action.push(
      this.trackPromise(
        this.dispatch(Actions.getClients({ cancelToken: clientsSource.token })),
        clientsSource
      )
    );
    const variablesSource = this.createCancelSource();
    action.push(
      this.trackPromise(
        this.dispatch(Actions.getVariables({ cancelToken: variablesSource.token })),
        variablesSource
      )
    );
    Promise.all(action)
      .catch(() => null)
      .finally(() => this.updateState({ loading: false, initLoad: false }));
  };

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb);
    }
  };

  addTimeout = (cb, delay = 0) => {
    const id = setTimeout(() => {
      this.timeouts.delete(id);
      cb();
    }, delay);
    this.timeouts.add(id);
    return id;
  };

  clearTimeouts = () => {
    this.timeouts.forEach((id) => clearTimeout(id));
    this.timeouts.clear();
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source));
    } else {
      this.releaseCancelSource(source);
    }
    return promise;
  };

  unsubscribeAll = () => {
    this.subs.forEach((token) => PubSub.unsubscribe(token));
    this.subs = [];
  };

  onSubmit = (form) => {
    if (this.readOnly) return;
    const body = {
      ...form.formData.personal,
      ...form.formData.coordonates,
      ...form.formData.poi,
      ...form.formData.mariageField,
    };
    if (!body.clientAttache) body.nom2 = "";
    this.updateState({ loading: true });
    (this.isNew
      ? this.dispatch(Actions.createClient(body))
      : this.dispatch(Actions.setClient(this.props.match.params.id, body))
    ).then((rep) => {
      PubSub.notif({
        txt: this.isNew
          ? "Votre client à été crée avec succes."
          : "Vos modifications ont été prises en compte.",
        color: "success",
        icon: "save",
      });
      this.updateState({ loading: false });
      if (this.isNew)
        this.props.history.push(
          queryString.parse(this.props.location.search).oncreate ||
            `/client/${rep.payload.id}`
        );
    });
  };

  render() {
    const c = this.props.classes;
    const { client, canDelete } = this.props;
    return (
      <div className={c.container}>
        <CustomTabs
          initTab={queryString.parse(this.props.location.search).tab}
          title={
            this.state.loading
              ? "Chargement en cours..."
              : (!this.isNew
                  ? client.nom + " " + client.prenom
                  : "Nouveau Client"
                ).toUpperCase()
          }
          headerColor="info"
          rigthBtn={
            !this.isNew && {
              display: !this.edit,
              icon: "create",
              onClick: (_) =>
                this.props.history.push(this.props.match.url + "/edit"),
            }
          }
          tabs={[
            {
              tabName: "Details",
              tabIcon: "assignment_ind",
              tabContent: (
                <Form
                  {...clientSchema(
                    this.props.client,
                    this.props.clients,
                    this.readOnly,
                    this.isNew
                  )}
                  formData={this.state.formData}
                  onChange={({ formData }) => this.updateState({ formData })}
                  initLoad={this.state.initLoad}
                  loading={this.state.loading}
                  readOnly={this.readOnly}
                  onSubmit={this.onSubmit}
                  onError={() => null}
                  removeEditOnSubmit
                />
              ),
            },
            {
              tabName: "Appartements",
              tabIcon: "home",
              tabContent: (
                <AssociationList
                  data={(this.props.client || {}).biens}
                  columns={appartementColumns}
                  noDataTxt="Aucun appartement assigné."
                  detailTxt="Voir les details de l'appartement"
                  onDetails={(o) =>
                    this.props.history.push(`/appartements/${o.id}`)
                  }
                  removeTxt="Retirer l'appartement"
                  onRemove={(apartId) =>
                    this.dispatch(Actions.removeOwner(apartId, this.props.client.id))
                  }
                  onAdd={(apartId) =>
                    this.dispatch(Actions.addOwner(apartId, this.props.client.id))
                  }
                  addTxt="Sélectionner un appartement"
                  addData={this.props.appartements}
                  addColumn={appartementColumns}
                  createTxt="Créer un appartement"
                  onCreate={(_) =>
                    this.props.history.push(
                      `/appartements/new?oncreate=${window.location.pathname}?tab=1`
                    )
                  }
                />
              ),
            },
            {
              tabName: "Missions",
              tabIcon: "work",
              tabContent: (
                <>
                  <h3>Missions en cours</h3>
                  <AssociationList
                    data={
                      (this.props.client || {}).Missions
                        ? (this.props.missions || []).filter((m) =>
                            this.props.client.Missions.some(
                              (mi) => mi.id === m.id
                            )
                          )
                        : []
                    } //istead of client.mission to get included value of mission
                    columns={missionColumns}
                    detailPanel={(rd) => (
                      <div style={{ background: "#EEE" }}>
                        <Form
                          {...missionSchema(
                            rd,
                            false,
                            this.isNew,
                            this.props.variables.tva.valeur,
                            (state) =>
                              this.updateState({
                                ["formDataMission_" + rd.id]: state,
                              })
                          )}
                          formData={this.state["formDataMission_" + rd.id]}
                          onSubmit={({ formData: { data } }) =>
                            this.dispatch(Actions.setMission(rd.id, data))
                          }
                        onError={() => null}
                        />
                      </div>
                    )}
                    onDetails={(o) =>
                      this.props.history.push(`/missions/${o.id}`)
                    }
                    detailTxt="Acceder aux détails de la mission"
                    noDataTxt="Aucune mission en cours."
                    removeTxt="Retirer la mission"
                    addTxt="Assigner une mission"
                    addColumn={missionColumns}
                    addData={this.props.missions}
                    createTxt="Créer une mission"
                    onCreate={(_) =>
                      this.props.history.push(
                        `/missions/new?oncreate=${window.location.pathname}?tab=2`
                      )
                    }
                    onAdd={(missionId) =>
                      this.dispatch(
                        Actions.addMissionCustomer(
                          missionId,
                          this.props.client.id
                        )
                      )
                    }
                    onRemove={(missionId) =>
                      this.dispatch(
                        Actions.removeMissionCustomer(
                          missionId,
                          this.props.client.id
                        )
                      )
                    }
                  />
                </>
              ),
            },
            {
              tabName: "Quittances",
              tabIcon: "receipt",
              tabContent: (
                <>
                  <AssociationList
                    data={(this.props.quitances || []).filter(
                      (q) => q.ClientId === this.props.match.params.id
                    )} //istead of client.mission to get included value of mission
                    columns={quitanceColumns}
                    actions={[
                      {
                        icon: "swap_horiz",
                        tooltip: "changer le status de paiement",
                        onClick: (event, rowData) =>
                          PubSub.confirm({
                            title: `Marquer la quittance commme ${
                              rowData.regle ? "non" : ""
                            } reglé`,
                            onAgree: (_) =>
                              this.dispatch(
                                Actions.setQuitance(rowData.id, {
                                  regle: !rowData.regle,
                                })
                              ),
                          }),
                      },
                      {
                        icon: "home",
                        tooltip: "Voir l'appartement",
                        onClick: (event, rowData) =>
                          this.props.history.push(
                            `/appartements/${rowData.Appartement.id}`
                          ),
                      },
                      {
                        icon: "assignment_ind",
                        tooltip: "Voir le client",
                        onClick: (event, rowData) =>
                          this.props.history.push(
                            `/client/${rowData.Client.id}`
                          ),
                      },
                      {
                        icon: "supervised_user_circle",
                        tooltip: "Voir le locataire",
                        onClick: (event, rowData) =>
                          this.props.history.push(
                            `/locataires/${rowData.Locataire.id}`
                          ),
                      },
                      canDelete && {
                        icon: "delete",
                        tooltip: "Supprimer le quittance",
                        onClick: (event, rowData) =>
                          PubSub.confirm({
                            title: "Supprimer la quittance ?",
                            subtitle: "Cette action est irreversible.",
                            onAgree: (_) =>
                              this.dispatch(Actions.deleteQuitance(rowData.id)),
                          }),
                      },
                    ]}
                    noDataTxt="Aucune quitance."
                  />
                </>
              ),
            },
            {
              tabName: "Fichiers",
              tabIcon: "description",
              tabContent: (
                <>
                  <h3>{`Fichier${
                    ((this.props.client || {}).Fichiers || []).length > 1
                      ? "s"
                      : ""
                  } lié au client`}</h3>
                  <AssociationList
                    data={(this.props.client || {}).Fichiers || []}
                    noDataTxt="Aucune fichier lié au client."
                    topRightButtonTxt="Ajouter un fichier"
                    onTopRightButton={(close) => (
                      <Form
                        style={{ width: "100%" }}
                        formData={this.state.newFileFormData}
                        {...fichierSchema(
                          {},
                          (data) => this.updateState({ newFileFormData: data }),
                          true,
                          false
                        )}
                        onSubmit={({ formData: { data } }) => {
                          this.dispatch(
                            Actions.addFichierClient(
                              this.props.match.params.id,
                              data
                            )
                          ).then(close);
                        }}
                        onError={() => null}
                      />
                    )}
                    columns={fichierColumns}
                    actions={[
                      {
                        icon: "get_app",
                        tooltip: "Télécharger le fichier",
                        onClick: (event, rowData) =>
                          downloadFile(
                            rowData.url,
                            `${client.nom} ${client.prenom}_${rowData.nom}.${rowData.extention}`
                          ),
                      },
                      {
                        icon: "publish",
                        tooltip: "Changer de fichier",
                        onClick: (event, rowData) =>
                          fileDialog("url").then((fd) =>
                            this.dispatch(Actions.setFichier(rowData.id, fd))
                          ),
                      },
                      canDelete && {
                        icon: "delete",
                        tooltip: "supprimer le fichier",
                        onClick: (event, rowData) =>
                              PubSub.confirm({
                                title: "Supprimer le fichier ?",
                                subtitle: "Cette action est irreversible.",
                                onAgree: (_) =>
                                  this.dispatch(Actions.deleteFichier(rowData.id)).then(
                                    (_) => this.loadData()
                                  ),
                              }),
                          },
                        ]}
                  />
                </>
              ),
            },
          ].filter((t) => !this.isNew || t.tabName === "Details")}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {
    marginTop: 30,
  },
  formCard: {
    margin: "auto",
  },
});

const mapStateToProps = (state) => ({
  client: state.reducer.client,
  appartements: state.reducer.appartements,
  missions: state.reducer.missions,
  clients: state.reducer.clients,
  variables: state.reducer.variables,
  quitances: state.reducer.quitances,
  canDelete: state.reducer.canDelete,
});
export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(FormEditor))
);

// l'idée serait de faire un refacto en passant d'une class avec des cycles de vie à une utilisation des hooks avec une fonction
// maintenabilité améliorée, optimisation car plus efficace, code mis à jour avec les dernières pratiques
